import { MARKETPLACE_QUALITY_LEVELS } from '../../constants';

export const MARKETPLACE_QUALITY_LEVEL_ORDER = [
  MARKETPLACE_QUALITY_LEVELS.BAD,
  MARKETPLACE_QUALITY_LEVELS.REGULAR,
  MARKETPLACE_QUALITY_LEVELS.GOOD,
  MARKETPLACE_QUALITY_LEVELS.VERY_GOOD,
];

export const MARKETPLACE_QUALITY_LEVEL_CONFIG = {
  [MARKETPLACE_QUALITY_LEVELS.BAD]: {
    id: MARKETPLACE_QUALITY_LEVELS.BAD,
    translationKey: 'MarketplaceQualityBad',
    variant: 'critical',
  },
  [MARKETPLACE_QUALITY_LEVELS.REGULAR]: {
    id: MARKETPLACE_QUALITY_LEVELS.REGULAR,
    translationKey: 'MarketplaceQualityRegular',
    variant: 'warning',
  },
  [MARKETPLACE_QUALITY_LEVELS.GOOD]: {
    id: MARKETPLACE_QUALITY_LEVELS.GOOD,
    translationKey: 'MarketplaceQualityGood',
    variant: 'positive',
  },
  [MARKETPLACE_QUALITY_LEVELS.VERY_GOOD]: {
    id: MARKETPLACE_QUALITY_LEVELS.VERY_GOOD,
    translationKey: 'MarketplaceQualityVeryGood',
    variant: 'info',
  },
};

const LEVEL_ALIASES = {
  very_bad: MARKETPLACE_QUALITY_LEVELS.BAD,
  muito_ruim: MARKETPLACE_QUALITY_LEVELS.BAD,
  bad: MARKETPLACE_QUALITY_LEVELS.BAD,
  ruim: MARKETPLACE_QUALITY_LEVELS.BAD,
  regular: MARKETPLACE_QUALITY_LEVELS.REGULAR,
  good: MARKETPLACE_QUALITY_LEVELS.GOOD,
  bom: MARKETPLACE_QUALITY_LEVELS.GOOD,
  very_good: MARKETPLACE_QUALITY_LEVELS.VERY_GOOD,
  muito_bom: MARKETPLACE_QUALITY_LEVELS.VERY_GOOD,
};

const QUALITY_ID_TO_LEVEL = {
  2: MARKETPLACE_QUALITY_LEVELS.BAD,
  3: MARKETPLACE_QUALITY_LEVELS.REGULAR,
  4: MARKETPLACE_QUALITY_LEVELS.GOOD,
  5: MARKETPLACE_QUALITY_LEVELS.VERY_GOOD,
};

const normalizeLevelId = (id) => {
  if (!id) return null;
  const numId = Number(id);
  if (!Number.isNaN(numId) && QUALITY_ID_TO_LEVEL[numId]) {
    return QUALITY_ID_TO_LEVEL[numId];
  }
  return LEVEL_ALIASES[String(id).toLowerCase()] ?? null;
};

const getCountFromValue = (value) => {
  if (value == null) return 0;
  if (typeof value === 'object') return Number(value.count) || 0;
  return Number(value) || 0;
};

const getUrlFromValue = (value) => {
  if (value && typeof value === 'object') return value.redirect_url || null;
  return null;
};

const addLevelSource = (byId, id, value) => {
  const count = getCountFromValue(value);
  const url = getUrlFromValue(value);
  const current = byId[id] || { count: 0, url: null };

  byId[id] = {
    count: current.count + count,
    url: url || current.url,
  };
};

export function formatMarketplaceQualityCount(count, locale = 'es-AR') {
  const numericCount = Number(count) || 0;
  return numericCount.toLocaleString(locale);
}

export function mapMarketplaceQualityLevels(payload = []) {
  const byId = {};

  if (Array.isArray(payload)) {
    payload.forEach((item) => {
      const id = normalizeLevelId(item?.quality_id);
      if (!id) return;
      addLevelSource(byId, id, item);
    });
  } else if (payload && typeof payload === 'object') {
    Object.entries(payload).forEach(([key, value]) => {
      const id = normalizeLevelId(key);
      if (!id) return;
      addLevelSource(byId, id, value);
    });
  }

  return MARKETPLACE_QUALITY_LEVEL_ORDER.map((id) => {
    const source = byId[id] || {};
    return {
      ...MARKETPLACE_QUALITY_LEVEL_CONFIG[id],
      count: source.count || 0,
      url: source.url || null,
    };
  });
}

export function getMarketplaceQualityTotal(count, levels = []) {
  if (count != null && count !== '') {
    return Number(count) || 0;
  }

  return levels.reduce((total, level) => total + (Number(level.count) || 0), 0);
}

export function isMarketplaceQualityEmpty(levels = []) {
  if (!levels.length) return true;
  return levels.every((level) => Number(level.count) === 0);
}
